export default class MembershipNumber {
	nextNumber = 2000
}